import { PLANS, type FeatureId, type PlanId } from '@billing/plans';
import {
  BookMarked,
  BookOpenText,
  ChartColumn,
  CircleOff,
  GlassWater,
  ImagePlus,
  LucideIcon,
  Martini,
  MessagesSquare,
  NotebookPen,
  ScanText,
  Search,
  Users
} from 'lucide-react';

/** One icon per plan feature, for upgrade highlights. */
export const FEATURE_ICONS: Record<FeatureId, LucideIcon> = {
  classic_recipes: Martini,
  house_recipes: GlassWater,
  menus: BookOpenText,
  eighty_six: CircleOff,
  messages: MessagesSquare,
  team: Users,
  logbook: NotebookPen,
  ai_menu_import: ScanText,
  custom_reports: ChartColumn,
  ai_images: ImagePlus,
  references: BookMarked,
  knowledge_search: Search
};

/**
 * Up to four features `target` adds over `current`, `lead` first when given:
 * the highlights an upgrade card lists.
 */
export function upgradeHighlightFeatures(
  current: readonly FeatureId[],
  target: PlanId,
  lead?: FeatureId
): FeatureId[] {
  const gained = PLANS[target].features.filter(
    feature => !current.includes(feature) && feature !== lead
  );
  return [...(lead ? [lead] : []), ...gained].slice(0, 4);
}
